import React, { useState, useEffect } from "react";
import api from "../../utils/apiClient";
import Navbar from "../Navbar";
import Foooter from "../Foooter";
import FooterMovil from "../FooterMovil";
import { AdminSidebar, AdminSidebarDropdown } from "../AdminSidebar";
import { useAuth } from "../../context/AuthContext.js";
import { useNavigate } from "react-router-dom";
import "../../style/AllCarsAdmin.css";
import "../../style/AuctionReports.css";

function AuctionReports() {
  const { authToken, logout } = useAuth();
  const [username, setUsername] = useState("");
  const [auctions, setAuctions] = useState([]);
  const [search, setSearch] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const getuser = async () => {
      try {
        const response = await api.get("usuario/getbyToken");
        setUsername(response.data.nombre);
      } catch (error) {
        console.error("Error fetching user", error);
      }
    };
    if (!authToken) {
      navigate("/");
    }
    getuser();
    fetchAuctions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchAuctions = async () => {
    try {
      const res = await api.get("auctions/Admin");
      setAuctions(res.data);
    } catch (err) {
      console.error("Error fetching auctions", err);
    }
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <>
      <Navbar />
      <div className="containers">
        <div className="main-container-admin-a">
          <AdminSidebar username={username} onLogout={handleLogout} />
          <div className="column-info-all">
            <AdminSidebarDropdown onLogout={handleLogout} />

            <div className="auction-reports-page">
              <div className="ar-header">
                <h2 className="ar-page-title">Reporte de Subastas</h2>
                <p className="ar-subtitle">
                  Explora los detalles de cada subasta — pujas, compradores de tickets y más
                </p>
              </div>

              <div className="ar-search-bar">
                <input
                  type="text"
                  className="ar-search-input"
                  placeholder="Buscar subasta o auto"
                  value={search}
                  onChange={handleSearchChange}
                />
              </div>

              {(() => {
                const filtered = auctions.filter((auc) => {
                  const carName = auc.Carro
                    ? `${auc.Carro.marca} ${auc.Carro.modelo} ${auc.Carro.anio}`
                    : "";
                  return (
                    auc._id.toLowerCase().includes(search.toLowerCase()) ||
                    carName.toLowerCase().includes(search.toLowerCase())
                  );
                });

                if (filtered.length === 0) {
                  return (
                    <div className="ar-empty">
                      <p className="ar-empty-title">
                        {auctions.length === 0
                          ? "No hay subastas registradas todavía"
                          : "No se encontraron subastas"}
                      </p>
                      {auctions.length > 0 && (
                        <p className="ar-empty-sub">
                          Prueba con otro término de búsqueda
                        </p>
                      )}
                    </div>
                  );
                }

                return (
                  <div className="ar-table-card">
                    <div className="ar-table-header">
                      <span className="ar-col ar-col-id">Subasta</span>
                      <span className="ar-col ar-col-auto">Auto</span>
                      <span className="ar-col ar-col-action" aria-hidden="true"></span>
                    </div>
                    <div className="ar-rows">
                      {filtered.map((auc) => (
                        <button
                          type="button"
                          key={auc._id}
                          className="ar-row"
                          onClick={() => navigate(`/auctionreports/${auc._id}`)}
                        >
                          <span className="ar-col ar-col-id">
                            <code className="ar-id-badge" title={auc._id}>
                              {auc._id}
                            </code>
                          </span>
                          <span className="ar-col ar-col-auto">
                            {auc.Carro
                              ? `${auc.Carro.marca} ${auc.Carro.modelo} ${auc.Carro.anio}`
                              : "—"}
                          </span>
                          <span className="ar-col ar-col-action">
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              aria-hidden="true"
                            >
                              <path d="M9 18l6-6-6-6" />
                            </svg>
                          </span>
                        </button>
                      ))}
                    </div>
                  </div>
                );
              })()}
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <Foooter />
      </div>
      <div className="footer-movil">
        <FooterMovil />
      </div>
    </>
  );
}

export default AuctionReports;
